const FRAMES = `${process.env.PUBLIC_URL}/UI/effects/splat`;

//TODO: See if there's a less repetitive way to do this
export default {
  0: `${FRAMES}/splat_00032.png`,
  1: `${FRAMES}/splat_00033.png`,
  2: `${FRAMES}/splat_00034.png`,
  3: `${FRAMES}/splat_00035.png`,
  4: `${FRAMES}/splat_00036.png`,
  5: `${FRAMES}/splat_00037.png`,
  6: `${FRAMES}/splat_00038.png`,
  7: `${FRAMES}/splat_00039.png`,
  8: `${FRAMES}/splat_00040.png`,
  9: `${FRAMES}/splat_00041.png`,
  10: `${FRAMES}/splat_00042.png`,
  11: `${FRAMES}/splat_00043.png`,
  12: `${FRAMES}/splat_00044.png`,
  13: `${FRAMES}/splat_00045.png`,
  14: `${FRAMES}/splat_00046.png`,
  15: `${FRAMES}/splat_00047.png`,
  16: `${FRAMES}/splat_00048.png`,
  17: `${FRAMES}/splat_00049.png`,
  18: `${FRAMES}/splat_00050.png`,
  19: `${FRAMES}/splat_00051.png`,
  20: `${FRAMES}/splat_00052.png`,
  21: `${FRAMES}/splat_00053.png`,
  22: `${FRAMES}/splat_00054.png`,
  23: `${FRAMES}/splat_00055.png`,
  24: `${FRAMES}/splat_00056.png`,
  25: `${FRAMES}/splat_00057.png`,
  26: `${FRAMES}/splat_00058.png`,
  27: `${FRAMES}/splat_00059.png`,
  28: `${FRAMES}/splat_00060.png`,
  29: `${FRAMES}/splat_00061.png`,
  30: `${FRAMES}/splat_00062.png`,
  31: `${FRAMES}/splat_00063.png`,
  32: `${FRAMES}/splat_00064.png`,
  33: `${FRAMES}/splat_00065.png`,
  34: `${FRAMES}/splat_00066.png`,
  35: `${FRAMES}/splat_00067.png`,
  36: `${FRAMES}/splat_00068.png`,
  37: `${FRAMES}/splat_00069.png`,
  38: `${FRAMES}/splat_00070.png`,
  39: `${FRAMES}/splat_00071.png`,
  40: `${FRAMES}/splat_00072.png`,
  41: `${FRAMES}/splat_00073.png`,
  42: `${FRAMES}/splat_00074.png`,
  43: `${FRAMES}/splat_00075.png`,
  44: `${FRAMES}/splat_00076.png`,
  45: `${FRAMES}/splat_00077.png`,
  46: `${FRAMES}/splat_00078.png`,
  47: `${FRAMES}/splat_00079.png`,
  48: `${FRAMES}/splat_00080.png`,
  49: `${FRAMES}/splat_00081.png`,
  50: `${FRAMES}/splat_00082.png`,
  51: `${FRAMES}/splat_00083.png`,
  52: `${FRAMES}/splat_00084.png`,
  53: `${FRAMES}/splat_00085.png`,
  54: `${FRAMES}/splat_00086.png`,
  55: `${FRAMES}/splat_00087.png`,
  56: `${FRAMES}/splat_00088.png`,
  57: `${FRAMES}/splat_00089.png`,
  58: `${FRAMES}/splat_00090.png`,
  59: `${FRAMES}/splat_00091.png`,
  60: `${FRAMES}/splat_00092.png`,
  61: `${FRAMES}/splat_00093.png`,
  62: `${FRAMES}/splat_00094.png`,
  63: `${FRAMES}/splat_00095.png`,
  64: `${FRAMES}/splat_00096.png`,
  65: `${FRAMES}/splat_00097.png`,
}
